/* eslint-disable no-unused-vars*/
import React, { useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Col, Form, Input, Row, Switch, Skeleton, DatePicker, Select } from 'antd';
import { ArrowLeftOutlined, SaveOutlined } from '@ant-design/icons';
import { postCreateAutomaticallyLimitnumber, getAutomaticallyLimitnumberById, putUpdateAutomaticallyLimitnumber } from 'api/automaticallyLimitnumber';
import { getLotteryTypeAll } from 'api/lotteryType';
import { getCookie } from 'helper/cookie';
import Swal from 'sweetalert2';
import { get } from 'lodash';
import { messageRequireIcon } from 'common/messageError/message.common';
// import { ButtonEditOutline } from 'common/Button/Button.styles';
// import moment from 'moment';
import dayjs from 'dayjs';
import moment from 'moment';
export const formatDate = 'YYYY-MM-DDTHH:mm:ssZ';
import { Editor } from '@tinymce/tinymce-react';
import { VITE_REACT_TINY_API_KEY } from 'src/private/config';

const { Option } = Select;

interface propType {
   id: number;
}

const CreateAutomaticallyLimitnumber = (props : propType) => {
   const { id } = props;
   const isMobileView = useSelector((state) => get(state, 'device.isMobileView', false));
   const [form] = Form.useForm();
   const navigate = useNavigate();
   const token = getCookie('access_tokenltl');
   const [data, setData] = useState<any>([]);
   const [isLoading, setIsLoading] = useState(false);
   const [dataLotteryType, setDataLotteryType] = useState<any>([])
   const [isLoadingDataLotteryType, setIsLoadingDataLotteryType] = useState(false);
   const dataUser: any = getCookie('dataUser');
   const parseDataUser = dataUser ? JSON.parse(dataUser) : null;
   const [lotteryType, setLotteryType] = useState<any>('');

   const fetchLotteryTypeMyData = useCallback(
      async (query: any) => {
         setIsLoadingDataLotteryType(true);
         const params = {
            ids: parseDataUser?.lottery_type
         };
         try {
            const responseData = await getLotteryTypeAll({ token, params: params });
            if (responseData?.status === 200) {
               const { data } = responseData;
               
               setDataLotteryType(data?.data?.lottery_type);
               setIsLoadingDataLotteryType(false);
            } else {
               setDataLotteryType('');
               setIsLoadingDataLotteryType(false);
            }
         } catch (error) {
            setIsLoadingDataLotteryType(false);
         }
      },
      [token, id],
   );

   useMemo(() => {
      if (token && parseDataUser) {
         fetchLotteryTypeMyData(parseDataUser?.lottery_type);
      }
   }, [token, id]);

   const fetchAutomaticallyLimitnumberById = useCallback(
      async (query: any) => {
         setIsLoading(true);
         const params = {
            id: id,
         };
         try {
            const responseData = await getAutomaticallyLimitnumberById({ token, params: params });
            if (responseData?.status === 200) {
               const { data } = responseData;
               setData(data?.data);
           
               setIsLoading(false);
               form.setFieldsValue({
                  lottery_type_id : data?.data?.lottery_type_id,
                  owner_id  : data?.data?.owner_id,
                  group_user_id   : data?.data?.group_user_id ,
                  automatically_limitnumber_status: data?.data?.automatically_limitnumber_status
               });
            } else {
               if(responseData?.status === 404){
                  navigate(`/backoffice/automatically_limitnumber`, { replace: false });
               }
               setData('');
               setIsLoading(false);
            }
         } catch (error) {
            setIsLoading(false);
         }
      },
      [token, id],
   );

   useMemo(() => {
      if (id && token) {
         fetchAutomaticallyLimitnumberById(id);
      }
   }, [id, token]);

   
   const renderPrice = () => {
      if (isLoadingDataLotteryType === false) {
         return dataLotteryType?.map((value: any, index: number) => {
            if(id){
               if(data?.lottery_type_id === value?.id){
                  return (
                     <Option value={value?.id} key={index}>{value?.lottery_type_name} | เปิดได้สูงสุด ({value?.lottery_type_max_count} งวด)</Option>
                  );
               }
            } else {
               return (
                  <Option value={value?.id} key={index}>{value?.lottery_type_name} | เปิดได้สูงสุด ({value?.lottery_type_max_count} งวด)</Option>
               );
            }
           
         });
      }
      return [];
   }
   
   const handleSubmit = async (values: any) => {
      const params = {
         lottery_type_id : lotteryType ? lotteryType : Number(data?.lottery_type_id), //values.lottery_type_id ,
         automatically_limitnumber_status: values?.automatically_limitnumber_status,
      };
      // console.log(dayjs(values.automatically_limitnumber_end_date, 'YYYY/MM/DD'),)
      // console.log(values?.automatically_limitnumber_end_date.format('YYYY-MM-DD'))

      if (id) {
         const updateData = await putUpdateAutomaticallyLimitnumber({ token, params: params, id: id });
         if (updateData.status === 200) {
            Swal.fire({
               icon: 'success',
               title: 'อัปเดตข้อมูลสำเร็จ',
               showConfirmButton: false,
               timer: 5000,
            });
            await fetchAutomaticallyLimitnumberById(id)
         } else {
            Swal.fire({
               icon: 'error',
               title: updateData?.message ? updateData?.message : 'อัปเดตข้อมูลไม่สำเร็จ',
               showConfirmButton: false,
               timer: 5000,
            });
         }
      } else {
         const createData = await postCreateAutomaticallyLimitnumber({ token, params: params });
         if (createData.status === 200) {
            Swal.fire({
               icon: 'success',
               title: 'บันทึกข้อมูลสำเร็จ',
               showConfirmButton: false,
               timer: 5000,
            });
            await fetchAutomaticallyLimitnumberById(id)
            navigate(`/backoffice/automatically_limitnumber/edit/${createData?.data?.data?.id}`, { replace: true });
         } else {
            Swal.fire({
               icon: 'error',
               title: createData?.data?.message ? createData?.data?.message : 'บันทึกข้อมูลไม่สำเร็จ',
               showConfirmButton: false,
               timer: 5000,
            });
         }
      }
   };

   return (
      <>
         {isLoading === false ? (
            <Form
               layout="vertical"
               autoComplete="off"
               onFinish={handleSubmit}
               form={form}
               initialValues={{
                  lottery_type_id: null,
                  automatically_limitnumber_detail: '',
               }}
            >
               <Row gutter={16} justify="space-between">
                  <Col span={isMobileView ? 24 :24}>
                     <Form.Item
                        name="lottery_type_id"
                        label="ประเภทหวย"
                        rules={[
                           {
                              required: true,
                              message: messageRequireIcon('กรุณากรอกข้อมูล ประเภทหวย'),
                           },
                        ]}
                     >
                        <Select placeholder="กรุณาเลือก ประเภทหวย"
                           onChange={(e, option: any) => {
                              setLotteryType(option?.value)
                           }}
                        >
                           {renderPrice()}
                        </Select>
                     </Form.Item>
                  </Col>
                  <Col span={isMobileView ? 24 :24}>
                     <Form.Item
                        name="automatically_limitnumber_status"
                        label="การใช้งานเลขอั้นอัตโนมัติ"
                        rules={[
                           {
                              required: true,
                              message: messageRequireIcon('กรุณาเลือก การใช้งานเลขอั้นอัตโนมัติ'),
                           },
                        ]}
                     >
                        <Select placeholder="กรุณาเลือก การใช้งานเลขอั้นอัตโนัมติ"
                        >
                           <Option value={'Y'} key={1}>เปิดใช้งาน</Option>
                           <Option value={'N'} key={2}>ปิดใช้งาน</Option>
                        </Select>
                     </Form.Item>
                  </Col>
                  
               </Row>
    
               <div className='clearfix mt-3' />
               <Row>
                  <Col span={12}>
                     <Link to="/backoffice/automatically_limitnumber">
                        <Button type='text' htmlType="button" size='large' className="btn btn-md btn-secondary">
                           <ArrowLeftOutlined /> ย้อนกลับ
                        </Button>
                     </Link>
                  </Col>
                  <Col span={12}>
                     <Button type="primary" htmlType="submit" size='large' className="btn btn-md" style={{ float: 'right' }}>
                        <SaveOutlined /> {id ? 'อัปเดตข้อมูล' :`เพิ่มข้อมูล`}
                     </Button>
                  </Col>
               </Row>
            </Form>
         )
            : (
               <Skeleton active />
            )
         }
      </>
   );
};

export default CreateAutomaticallyLimitnumber;
